import { SxProps, Theme } from '@mui/material';

export const useStyles = (theme: Theme): { [key: string]: SxProps<Theme> } => ({
  container: {
    my: '60px',

    [theme.breakpoints.between('md', 'lg')]: {
      height: '750px',
    },

    [theme.breakpoints.down('md')]: {
      my: '64px',
      height: 'fit-content',
      alignItems: 'center',
    },
  },

  box: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.between('md', 'lg')]: {},

    [theme.breakpoints.between('sm', 'md')]: {},

    [theme.breakpoints.down('sm')]: {},
  },

  cardBox: {
    display: 'flex',
    justifyContent: 'space-evenly',
    mt: '120px',

    [theme.breakpoints.down('lg')]: {
      mt: '100px',
    },

    [theme.breakpoints.down('md')]: {
      mt: '64px',
      flexDirection: 'column',
      alignItems: 'center',
      mb: '64px',
    },
  },

  card: {
    backgroundColor: 'grey.200',
    height: '446px',
    width: '330px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '70px 20px 30px 20px',

    [theme.breakpoints.down('md')]: {
      backgroundColor: 'white',
      mt: '40px',
      boxShadow: '0px 12px 24px -4px rgb(145 158 171 / 12%)',
    },
  },

  centralCard: {
    height: '446px',
    width: '330px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px 20px 20px 20px',
    boxShadow: '-40px 40px 80px rgb(145 158 171/ 40%)',
    mt: '-40px',

    [theme.breakpoints.down('md')]: {
      backgroundColor: 'white',
      mt: '40px',
      boxShadow: '0px 12px 24px -4px rgb(145 158 171 / 12%)',
    },
  },

  centralCardInside: {
    backgroundColor: 'white',
    height: '406px',
    width: '292px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '70px 20px 30px 20px',
    boxShadow: '-20px 20px 40px rgb(145 158 171 / 24%)',

    [theme.breakpoints.down('md')]: {
      backgroundColor: 'white',
      height: '446px',
      width: '330px',
      boxShadow: 'none',
    },
  },

  text: {
    fontWeight: 400,
    fontSize: '16px',
    color: 'grey.600',
  },

  bigText: {
    color: 'grey.800',
    fontSize: '48px',
    fontWeight: 700,

    [theme.breakpoints.down('md')]: {
      fontSize: '32px',
    },
  },

  cardHeaderText: {
    fontSize: '20px',
    fontWeight: 700,
  },

  iconBlue: {
    width: '50px',
    height: '50px',
    color: 'info.main',
  },

  iconRed: {
    width: '30px',
    height: '30px',
    color: 'error.main',
  },

  iconOrange: {
    width: '50px',
    height: '50px',
    color: 'warning.main',
  },
});
